import { Box } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { commonStyle } from '../common/styles';
import { LanguageContext } from '../context/LanguageContextProvider';
import { TransitsContext } from '../context/TransitsContextProvider';

const WIDTH = 280;
const HEIGHT = 100;

const MESSAGE =
  '情報が取得できません。\nしばらくしてから\n再度アクセスしてください。';
const MESSAGE_EN = 'Failed to get information.\nPlease try again later.';

// 位置情報取得不可時に固定表示するメッセージ
const ErrorGetTransits: React.FC = () => {
  const { failedGetTransits } = useContext(TransitsContext);
  const { language } = useContext(LanguageContext);

  return (
    <>
      {failedGetTransits && (
        <Box
          w={WIDTH}
          h={HEIGHT}
          top={`calc(12%)`}
          left={`calc(50% - ${WIDTH / 2}px)`}
          position='fixed'
          color='white'
          bgColor='black'
          fontSize={language === 'en' ? '18px' : '16px'}
          fontWeight='bold'
          border='solid 3px #FFC000'
          borderRadius='20px'
          padding='5px 10px'
          sx={{ ...commonStyle.center }}
          wordBreak='break-word'
          whiteSpace='pre-wrap'
        >
          {language === 'en' ? MESSAGE_EN : MESSAGE}
        </Box>
      )}
    </>
  );
};

export default React.memo(ErrorGetTransits);
